/**
 * WhyWallet — «ليش Wallet» bento: two wide tiles with illustrations (wallet stack,
 * auto-update) and three small tiles (an icon list on phones).
 */
import React from 'react';
import { Analytics01Icon, CheckmarkCircle02Icon, QrCodeIcon, TranslateIcon } from '@hugeicons/core-free-icons';
import Icon from '../../components/v2/Icon.jsx';
import { useStr } from './useStr.js';
import { KHALID, ME_DARK, PHOTO_URL, SARA } from './data.js';
import PassSlot from './PassSlot.jsx';

const L = ({ children, className = '' }) => <span className={`ltr${className ? ` ${className}` : ''}`}>{children}</span>;

export default function WhyWallet() {
  const { t, ar } = useStr();
  return (
    <section className="sx">
      <div className="wrap">
        <div className="shead c" id="why">
          <div className="eb">{t('whyEb')}</div>
          <h2 className="h">{t('whyT1')}<br /><span className="mute">{t('whyT2')}</span></h2>
        </div>
        <div className="bento">
          <div className="tile w3">
            <div className="tv" aria-hidden="true">
              <div className="wstack">
                <PassSlot card={KHALID} scale={0.92} scaleT={0.84} clip={56} />
                <PassSlot card={SARA} scale={0.92} scaleT={0.84} clip={56} />
                <PassSlot card={ME_DARK} photoUrl={PHOTO_URL} scale={0.92} scaleT={0.84} clip={112} />
              </div>
            </div>
            <div className="lb">{t('f1L')}</div>
            <h3>{t('f1T')}</h3>
            <p>
              {ar
                ? <>آيفون أو أندرويد، بطاقتك في <span className="nw">Apple Wallet</span> أو <span className="nw">Google Wallet</span>، تطلع من شاشة القفل بدون ما تفتح أي تطبيق.</>
                : <>iPhone or Android, your card lives in <span className="nw">Apple Wallet</span> or <span className="nw">Google Wallet</span>, right from the lock screen. No app to open.</>}
            </p>
          </div>
          <div className="tile w3">
            <div className="tv" aria-hidden="true">
              <div className="upd">
                <div className="mini">
                  <div className="l">{t('fTitle')}</div>
                  <div className="in"><L>Regional Sales Manager<span className="caret" /></L></div>
                  <div className="old ltr vr">Sales Manager</div>
                </div>
                <div className="syn">
                  {['syn1', 'syn2', 'syn3'].map((k) => <div key={k}><Icon icon={CheckmarkCircle02Icon} />{t(k)}</div>)}
                </div>
              </div>
            </div>
            <div className="lb">{t('f2L')}</div>
            <h3>{t('f2T')}</h3>
            <p>{t('f2D')}</p>
          </div>
          <div className="smalls">
            <div className="tile w2">
              <span className="ic-t g3"><Icon icon={QrCodeIcon} /></span>
              <div className="lb">{t('f3L')}</div>
              <h3>{t('f3T')}</h3>
              <p>
                {ar
                  ? <>الطرف الثاني يصوّر <span className="nw">الـ <L>QR</L>،</span> وجواله، آيفون أو أندرويد، يحفظ بياناتك جهة اتصال فورًا.</>
                  : 'The receiver scans the QR and their phone, iPhone or Android, saves your details as a contact instantly.'}
              </p>
            </div>
            <div className="tile w2">
              <span className="ic-t g2"><Icon icon={TranslateIcon} /></span>
              <div className="lb">{t('f4L')}</div>
              <h3>{t('f4T')}</h3>
              <p>{t('f4D')}</p>
            </div>
            <div className="tile w2">
              <span className="ic-t g4"><Icon icon={Analytics01Icon} /></span>
              <div className="lb">{t('f5L')}</div>
              <h3>{t('f5T')}</h3>
              <p>
                {ar
                  ? <>كل مسح <L>QR</L> ينحسب. اعرف أي فعالية أو اجتماع يجيب لك عملاء أكثر.</>
                  : 'Every QR scan is counted. See which events and meetings bring you the most leads.'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
